/* eslint-disable no-unsafe-finally */
import axios from 'axios';

export class D2Api {
  #vm = null;

  #loading = null

  constructor(vm, options = {}) {
    this.#vm = vm;
    this.#loading = options.loader ?? 'loading';
  }

  set loading(val) {
    this.#vm.$data[this.#loading] = val;
  }

  // eslint-disable-next-line class-methods-use-this
  initResult() {
    return {
      success: true,
      data: null,
      errors: [],
    };
  }

  get formObserver() {
    const childObserver = this.#vm.$children.find((m) => m.$refs.formObserver);
    return this.#vm.$refs.formObserver || childObserver.$refs.formObserver;
  }

  async getData(url) {
    this.loading = true;
    const result = this.initResult();
    try {
      const { data } = await axios.get(url);
      result.data = data;
    } catch (error) {
      result.success = false;
      this.formObserver.setErrors({ generic: error.response.data });
      result.errors = [];
    } finally {
      this.loading = false;
      return result;
    }
  }

  async getPaged(url, pagination = {}, filter = '') {
    this.loading = true;
    const result = this.initResult();
    const {
      page = 1, sortOrder = 'desc', pageSize = '20', sortField,
    } = pagination;
    const params = [`filter=${filter}`, `sortDir=${sortField} ${sortOrder}`, `currentPage=${page}`, `pageSize=${pageSize}`].join('&');
    this.loading = true;
    try {
      const { data } = await axios.get(`${url}?${params}`);
      result.resultItems = data.resultItems;
      result.total = data.totalRecords;
    } catch (error) {
      result.success = false;
      this.formObserver.setErrors({ generic: error.response.data });
      result.errors = [];
    } finally {
      this.loading = false;
      return result;
    }
  }

  async postForm(url, form) {
    this.loading = true;
    const result = this.initResult();
    try {
      const { data } = await axios.post(url, form);
      result.data = data;
    } catch (error) {
      result.success = false;
      this.formObserver.setErrors({ generic: error.response.data });
      result.errors = [];
    } finally {
      this.loading = false;
      return result;
    }
  }

  async patchForm(url, form) {
    this.loading = true;
    const result = this.initResult();
    try {
      const { data } = await axios.patch(url, form);
      result.data = data;
    } catch (error) {
      result.success = false;
      this.formObserver.setErrors({ generic: error.response.data });
      result.errors = [];
    } finally {
      this.loading = false;
      return result;
    }
  }
}

export default D2Api;